import { render, staticRenderFns } from "./Varicela.vue?vue&type=template&id=434432ee"
import script from "./Varicela.vue?vue&type=script&lang=js"
export * from "./Varicela.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports